import { useDevicePanel } from '@ubnt/link-core-ui/components/BottomPanel/context/DevicePanelContext';
import TooltipDescriptionContent from '@ubnt/link-core-ui/components/DevicePicker/components/TooltipDescriptionContent';
import InfoIndicator, { InfoIndicatorProps } from '@ubnt/link-core-ui/components/InfoIndicator/InfoIndicator';

import { useSelector } from 'app/store';
import { useApplicationStore } from 'modules/application/store';
import { devicesDeviceTooltipDescriptionSelector } from 'modules/devices/slice';

const InfoIcon = (props: Partial<InfoIndicatorProps>) => {
  const { id } = useDevicePanel();

  const tooltipDescription = useSelector((state) => id && devicesDeviceTooltipDescriptionSelector(state, id));
  const isMobile = useApplicationStore((state) => state.isMobile);

  if (!tooltipDescription || !isMobile) {
    return null;
  }

  return (
    <InfoIndicator severity="info2" {...props}>
      {<TooltipDescriptionContent description={tooltipDescription} />}
    </InfoIndicator>
  );
};

export default InfoIcon;
